import { Bot } from 'lucide-react';

interface EvaluatingStepProps {
  message?: string;
}

export default function EvaluatingStep({ message }: EvaluatingStepProps) {
  return (
    <div className="text-center py-12">
      <div className="relative inline-block">
        <Bot className="w-16 h-16 text-accent animate-pulse" />
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-accent rounded-full animate-ping" />
      </div>
      <h2 className="text-xl font-semibold text-white mt-6">
        {message || 'Reviewing your project...'}
      </h2>
      <p className="text-slate-400 mt-2">This usually takes about 10-15 seconds</p>
      <div className="flex justify-center gap-1 mt-6">
        <div className="w-2 h-2 bg-accent rounded-full animate-bounce [animation-delay:-0.3s]" />
        <div className="w-2 h-2 bg-accent rounded-full animate-bounce [animation-delay:-0.15s]" />
        <div className="w-2 h-2 bg-accent rounded-full animate-bounce" />
      </div>
    </div>
  );
}
